const formatAbbreviatedCurrency = value => {
  const absValue = Math.abs(value);

  if (absValue >= 1000000000) {
    return `$${(value / 1000000000).toFixed(1)}B`;
  }
  if (absValue >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  }
  if (absValue >= 1000) {
    return `$${(value / 1000).toFixed(0)}K`;
  }

  return `$${value.toFixed(0)}`;
};

export default formatAbbreviatedCurrency;
